export enum FullOrEmpty {
	Full = "FULL",
	Empty = "EMPTY"
}

export enum PlannedOrUnplanned {
	Planned = "planned",
	Unplanned = "unplanned"
}
